/*
 * Authors: mariushirjanu
 * Created: 03/11/2021
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICompanyExtended } from '../../../type_definitions/datatypes';
import { CompanyInfoService } from './company-info/company-info.service';

@Component({
  selector: 'company-dialog',
  template: `
    <company
      [companyId]="companyId"
      [companyName]="companyName"
      [showAsDialog]="true"
      (onSaved)="onCompanySaved($event)"
      (onCancel)="onCancel.emit()"
    >
    </company>
  `
})
export class CompanyDialogComponent implements OnInit {
  @Input() public component:string;
  @Input() public companyId:string;
  @Input() public companyName:string;
  @Input() public title:string;

  @Output() public onCancel:EventEmitter<void> = new EventEmitter<void>();
  @Output() public onSaved:EventEmitter<ICompanyExtended> = new EventEmitter<ICompanyExtended>();

  public ngOnInit():void {
    this.companyId = this.companyId || CompanyInfoService.NEW_COMPANY;
  }

  public onCompanySaved(companyData:ICompanyExtended):void {
    this.onSaved.emit(companyData);
  }
}